module.exports = __webpack_public_path__ + "static/cloudcov-header-logo-6cb8a04592dfb5a86aa52866232083d1.png";